import NotificationService from "@/services/NotificationService.js";
import moment from "moment";

const state = {
  notification: {
    _id: null,
    title: "",
    body: "",
    image: true,
    clickUrl: "https://order.anewo.at",
    sendDate: moment().format("YYYY-MM-DD"),
    sendTime: moment()
      .minute(step5Min(moment().minute()))
      .format("HH:mm"),
    tokens: [],
  },
  notificationList: [],
};

const getters = {
  getNotification(state) {
    return state.notification;
  },
  getNotificationList(state) {
    return state.notificationList;
  },
};

const actions = {
  fetchNotificationList({ commit }) {
    return new Promise((resolve, reject) => {
      NotificationService.getAll()
        .then((response) => {
          commit("SET_NOTIFICATION_LIST", response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchNotification({ commit }, id) {
    return new Promise((resolve, reject) => {
      NotificationService.get(id)
        .then((response) => {
          commit("SET_NOTIFICATION", response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveNotification({ commit, state }) {
    return new Promise((resolve, reject) => {
      NotificationService.save(state.notification)
        .then((result) => {
          commit("ADD_NOTIFICATION", result.data.data);
          commit("RESET_CURRENT", result.data.data);
          return resolve(result.data.data);
        })
        .catch((error) => {
          console.log(error);
          return reject(error);
        });
    });
  },
  sendNotification({ commit, state }) {
    return new Promise((resolve, reject) => {
      NotificationService.send(state.notification)
        .then((result) => {
          commit("ADD_NOTIFICATION", result.data.data);
          commit("RESET_CURRENT", result.data.data);
          return resolve(result.data.data);
        })
        .catch((error) => {
          console.log(error);
          return reject(error);
        });
    });
  },
  deleteNotification({ commit }, id) {
    return new Promise((resolve, reject) => {
      NotificationService.delete(id)
        .then(() => {
          commit("REMOVE_NOTIFICATION", id);
          resolve(id);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  CREATE_NOTIFICATION(state, value) {
    state.notification = {
      _id: null,
      title: value.title,
      body: value.body,
      image: value.image,
      tokens: value.tokens,
      clickUrl: "https://order.anewo.at",
      sendDate: moment().format("YYYY-MM-DD"),
      sendTime: moment()
        .minute(step5Min(moment().minute()))
        .format("HH:mm"),
    };
  },
  SET_NOTIFICATION(state, value) {
    state.notification = value;
    /*state.notification.sendDate = moment(state.notification.sendDate).format(
      "YYYY-MM-DD"
    );*/
    state.notification.sendTime = moment(state.notification.sendDate).format(
      "HH:mm"
    );
  },
  SET_NOTIFICATION_TIME(state, value) {
    let mTime = moment(value);
    state.notification.sendTime = mTime
      .minute(step5Min(mTime.minute()))
      .format("HH:mm");
  },
  SET_NOTIFICATION_LIST(state, value) {
    state.notificationList = value;
  },
  ADD_NOTIFICATION(state, value) {
    state.notificationList.push(value);
  },
  RESET_CURRENT(state) {
    state.notification = {
      _id: null,
      title: "",
      body: "",
      image: true,
      clickUrl: "https://order.anewo.at",
      sendDate: moment().format("YYYY-MM-DD"),
      sendTime: "",
      tokens: [],
    };
  },
  REMOVE_NOTIFICATION(state, id) {
    if (state.notificationList) {
      state.notificationList = state.notificationList.filter(
        (item) => item._id !== id
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

function step5Min(minute) {
  if (minute > 0 && minute < 5) {
    return 5;
  } else if (minute > 5 && minute < 10) {
    return 10;
  } else if (minute > 10 && minute < 15) {
    return 15;
  } else if (minute > 15 && minute < 20) {
    return 20;
  } else if (minute > 20 && minute < 25) {
    return 25;
  } else if (minute > 25 && minute < 30) {
    return 30;
  } else if (minute > 30 && minute < 35) {
    return 35;
  } else if (minute > 35 && minute < 40) {
    return 40;
  } else if (minute > 40 && minute < 45) {
    return 45;
  } else if (minute > 45 && minute < 50) {
    return 50;
  } else if (minute > 50 && minute < 55) {
    return 55;
  } else if (minute > 55 && minute < 60) {
    return 0;
  } else {
    return minute;
  }
}
